/**
 * Generates the input for the plateImageGenerator mutation
 * @param {Object} variant - The variant object containing color, theme, and size info
 * @param {string} combination - The plate combination text
 * @returns {Object} The input object for generatePlateImage mutation
 */
const FONT_COLOUR_MAP = {
  black:  '000000',
  white:  'ffffff',
  green:  '1B5630',
  red:    'e31737',
  gold:   'c79e6f',
  silver: 'c0c0c0',
  blue:   '1a5fc0',
};

const deriveFontHex = (colourInfo) => {
  const str = colourInfo?.Colour || colourInfo?.DisplayName || '';
  const m = str.match(/^(\w+)_on_/i) || str.match(/with\s+(\w+)\s+font/i);
  return FONT_COLOUR_MAP[(m?.[1] || '').toLowerCase()] || '000000';
};

export const preparePlateImageInput = (variant, combination) => {
  const result = [];
    if(!variant) return;
    const xs = Object.entries(variant)
        .filter(([key]) => key.startsWith("Char") && key !== "CharsBaseline")
        .sort(([a], [b]) => a.localeCompare(b));

    const y = Number(variant.CharsBaseline);
    const rawFontHex = variant.ColourInfo?.ColourSelectorHexFont;
    const hex = rawFontHex ? rawFontHex.replace("#", "") : deriveFontHex(variant.ColourInfo);

    for (let i = 0; i < Math.min(xs.length, combination.length); i++) {
        const [xKey, xVal] = xs[i];
        const valueChar = combination[i];
        result.push({
            Position: {
                X: xVal,
                Y: y
            },
            Value: valueChar,
            ColourHexCode: hex
        })
    }
    const payload = {
        BackgroundUri: `${getFilename(variant.BaseImageId)}`,
        Elements: result,
        ImageSize: {
            Width: 520,
            Height: 140
        },
        Font: {
            Size: variant.ImageFontSize,
            "Source": `${variant.ImageFontType}.ttf`
        },
        "ConvolutionMatrix": variant.ConvolutionMatrix,
        "FontDarkeningFactor": variant.FontDarkeningFactor ?? 0
    }

    return payload;
};

/**
 * Converts base64 image data to a data URL for img src
 * @param {string} base64Data - The base64 encoded image string
 * @returns {string} Data URL for use in img src attribute
 */

export const getFilename = (value) => { 
    try { 
        // Try to parse as URL 
        const isUrl = /^https?:\/\//i.test(value);
        if (isUrl)
        {
            return value.split("/").pop().split("?")[0];
        }
        return value;
        } catch { 
            return value; } 
};

export const getPlateImageDataUrl = (base64Data) => {
  if (!base64Data) {
    return null;
  }
  return `data:image/png;base64,${base64Data}`;
};
